import React from "react";
import { ConfirmModal } from "./ConfirmModal";

export const ConfirmDeleteModal = ({ onDelete, confirmLabel = "Delete", ...rest }) => (
  <ConfirmModal confirmButtonProps={{ color: "danger" }} onConfirm={onDelete} confirmLabel={confirmLabel} {...rest} />
);
